import {Injectable} from '@angular/core';

import {Injector} from '@angular/core';
import {Observable, of, Subject} from 'rxjs';
import {HttpService, autoSubscribe} from 'projects/core/src/public-api';
import {NotificationsStore} from './notifications.store';
import {tap} from 'rxjs/operators';
import {NotificationResponcePage} from './notification-responce-page';
import {RecentNotificationsStore} from './recent-notifications.store';
import {Notification} from './notification';
import {MentionsCounter} from './mentions-counter';
import {MentionsStore} from 'projects/app-misc/src/app/modules/notification/data/mentions.store';
import {ShortTask} from '../../../../../../desktop/src/app/modules/home-page/data/tasks/short-task';


@Injectable({
  providedIn: 'root',
})
export class NotificationService extends HttpService {
  unreadMentions = new Subject<void>();

  constructor(
    protected injector: Injector,
    protected notificationsStore: NotificationsStore,
    protected mentionsStore: MentionsStore,
    protected recentNotificationsStore: RecentNotificationsStore
  ) {
    super(injector);
  }

  loadNotifications(start: number, limit: number): Observable<NotificationResponcePage> {
    return this.doHttpGet<NotificationResponcePage>(`/notification/my/list?start=${start}&limit=${limit}`)
      .pipe(
        tap(page => {
          this.notificationsStore.set(page.content)
          this.notificationsStore.updateTotal(page.totalElements)
        }),
        autoSubscribe()
      )
  }

  loadRecentNotifications(limit: number): Observable<NotificationResponcePage> {
    return this.doHttpGet<NotificationResponcePage>(`/notification/my/list?limit=${limit}`)
      .pipe(
        tap(page => {
          this.recentNotificationsStore.set(page.content)
        }),
        autoSubscribe()
      )
  }

  loadUnreadedNotificationsCount(): Observable<NotificationResponcePage> {
    return this.doHttpGet<NotificationResponcePage>(`/notification/unread/list?limit=1`)
      .pipe(
        tap(page => {
          this.notificationsStore.updateTotalUnread(page.totalElements)
        }),
        autoSubscribe()
      )
  }

  markNotificationAsRead(notificationId: number): Observable<void> {
    return this.putData(`/notification/${notificationId}/mark-as-read`, null, Object)
      .pipe(
        tap(() => {
          this.notificationsStore.update(notificationId, {
            readStatus: true
          })

          this.notificationsStore.decreaseTotalUnread()
        }),
        autoSubscribe()
      )
  }

  markAllNfsAsRead(): Observable<void> {
    return this.putData(`/notification/mark-all-as-read`, null, Object)
      .pipe(
        tap(status => {
          this.notificationsStore.update(null, {
            readStatus: true
          })
          this.notificationsStore.updateTotalUnread(0)
        })
      )
  }

  markProjectNfsAsRead(projectId: number): Observable<void> {
    return this.putData(`/notification/list/for-project/${projectId}/mark-as-read`, null, Object)
  }

  getNotificationsForProject(projectId: number): Observable<Notification[]> {
    return this.doHttpGet<Notification[]>(`/notification/list/for-project/${projectId}`)
  }

  // getNotificationsGroupId(groupId: number): Observable<Notification[]> {
  // 	return this.doHttpGet<Notification[]>(`/notification/list/for-group/${groupId}`)
  // }

  getNotificationsGroupId(groupId: number): Observable<Notification[]> {
    return this.doHttpGet<Notification[]>(`/notification/${groupId}/expanded`)
  }

  loadMentions(start: number, limit: number): Observable<NotificationResponcePage> {
    return this.doHttpGet<NotificationResponcePage>(`/notification/my/list/mentions?start=${start}&limit=${limit}`)
      .pipe(
        tap(page => {
          this.mentionsStore.set(page.content)
          this.mentionsStore.updateTotal(page.totalElements)
        }),
        autoSubscribe()
      )
  }

  getMentions(start: number, limit: number): Observable<NotificationResponcePage> {
    return this.doHttpGet<NotificationResponcePage>(`/notification/my/list/mentions?start=${start}&limit=${limit}`)
  }

  getAllMentions(): Observable<NotificationResponcePage> {
    return this.doHttpGet<NotificationResponcePage>(`/notification/my/list/mentions`)
  }

  getMentionsCounter(): Observable<MentionsCounter> {
    return this.doHttpGet<MentionsCounter>(`/notification/my/list/mentions/counter`)
  }

  getCountOfAlerts(): Observable<number> {
    return this.doHttpGet<number>(`/alert/active/count`)
  }

}
